<template>
  <ObjectsNav nav-context="data-access" />
</template>

<script>
import ObjectsNav from '@/components/objects/ObjectsNav';

export default {
  components: {
    ObjectsNav,
  },
};
</script>
